import { formatToCurrency } from '@porterin/component-library/src/utils/CurrencyUtils';
import React, { forwardRef } from 'react';
import { CurrencyConfig } from '../../domain/country/type';

const default_currencyConfig: CurrencyConfig = {
  currencyLocale: 'en-IN',
  currencyCode: 'INR',
  maxMinorDigits: 2,
  currencySymbol: '₹',
};

interface AmountTextProps extends React.HTMLAttributes<HTMLDivElement> {
  amount: number;
  class_name?: string;
  currency_config?: CurrencyConfig;
}

const AmountText = forwardRef<HTMLDivElement, AmountTextProps>(
  ({ amount, class_name = '', currency_config, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`text-[1.8rem] leading-[2rem] font-bold ${class_name}`}
        {...props}
      >
        {`${formatToCurrency(amount, currency_config ?? default_currencyConfig)}`}
      </div>
    );
  },
);

AmountText.displayName = 'AmountText';

export default AmountText;
